import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import ChartIcon from '@/components/exercises/ChartIcon.vue'
// load default config and extend it with tenant specific changes

import extendedConfig from '../tenants.js'

Vue.use(Vuetify)

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        accent: extendedConfig.VUE_CSS_BH_BLUE || '#00A0E0',
        bhWhite: extendedConfig.VUE_CSS_BH_WHITE || '#ffffff',
        bhBlack: extendedConfig.VUE_CSS_BH_BLACK || '#25282B',
        bhBlue1: extendedConfig.VUE_CSS_BH_BLUE_1 || '#2BB2E9',
        bhBlue2: extendedConfig.VUE_CSS_BH_BLUE_2 || '#45C2F4',
        bhBlue3: extendedConfig.VUE_CSS_BH_BLUE_3 || '#BDD0FF',
        bhBlue4: extendedConfig.VUE_CSS_BH_BLUE_4 || '#EBF0FF',
        bhBlue5: extendedConfig.VUE_CSS_BH_BLUE_5 || '#EEF2FE',
        bhGray1: extendedConfig.VUE_CSS_BH_GRAY_1 || '#52575C',
        bhGray2: extendedConfig.VUE_CSS_BH_GRAY_2 || '#A0A4A8',
        bhGray3: extendedConfig.VUE_CSS_BH_GRAY_3 || '#CACCCF',
        bhGray4: extendedConfig.VUE_CSS_BH_GRAY_4 || '#DBDDE0',
        bhGray5: extendedConfig.VUE_CSS_BH_GRAY_5 || '#E8E8E8',
        bhGray6: extendedConfig.VUE_CSS_BH_GRAY_6 || '#F6F8FB',
        bhNewGray: extendedConfig.VUE_CSS_BH_NEW_GRAY || '#F6F6FA',
        bhYellow: extendedConfig.VUE_CSS_BH_YELLOW || '#FAC032',
        bhYellowDark: extendedConfig.VUE_CSS_BH_YELLOW_DARK || '#EFAD0A',
        bhYellowLight: extendedConfig.VUE_CSS_BH_YELLOW_LIGHT || '#FCDF98',
        bhRed: extendedConfig.VUE_CSS_BH_RED || '#FF6760',
        bhRedDark: extendedConfig.VUE_CSS_BH_RED_DARK || '#E74F48',
        bhRedLight: extendedConfig.VUE_CSS_BH_RED_LIGHT || '#FF7E77',
        bhGreen1: extendedConfig.VUE_CSS_BH_GREEN_1 || '#16D090',
        bhGreen: extendedConfig.VUE_CSS_BH_GREEN || '#16d090',
        bhGreenDark: extendedConfig.VUE_CSS_BH_GREEN_DARK || '#03b575',
        bhGreenLight: extendedConfig.VUE_CSS_BH_GREEN_LIGHT || '#34eeae',
        mainColor: extendedConfig.VUE_CSS_MAIN_COLOR || '#213665',
      },
    },
  },
  icons: {
    values: {
      chart: {
        component: ChartIcon,
      },
    },
  },
})

export default vuetify
